'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@7f-ui/components/button/button';
import { shopAsset } from '@utils/utils-config';
import { shopTestId } from '@utils/utils-shop-test-ids';
import Image from 'next/image';
import Link from 'next/link';
export function CartEmpty() {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = shopTestId("CartEmpty.root");
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="relative col-span-6 col-start-1 flex aspect-square w-full justify-center sm:col-span-6 sm:col-start-4 md:col-span-5 md:col-start-7"><Image src={shopAsset("/images/empty-cart.png")} alt="Warenkorb ist leer" unoptimized={true} sizes="(max-width: 768px) 100vw, 50vw" fill={true} /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="fluid-grid fluid-container pt-4 sm:pt-32 md:pt-20 xlg:pt-48" data-testid={t0}>{t1}<div className="col-span-6 col-start-1 flex flex-col items-center justify-center text-center sm:col-span-12 md:col-span-4 md:col-start-2 md:row-start-1 md:items-start md:text-left"><div className="font-heading1">Dein Warenkorb ist leer.</div><p className="mt-2 mb-8 sm:mt-3">So vieles ist noch zu entdecken.</p><Button as={Link} href="/reiseziele/">Zu unseren Reisezielen</Button></div></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}